export const RAS_SET_FILTERS = 'RAS_SET_FILTERS';
export const RAS_SET_FILTERS_DATA = 'RAS_SET_FILTERS_DATA';
export const RAS_SET_FILTERS_LOADING = 'RAS_SET_FILTERS_LOADING';
export const RAS_SET_GRID = 'RAS_SET_GRID';
export const RAS_SET_ALL_REQUESTS = 'RAS_SET_ALL_REQUESTS';
export const RAS_SET_GRID_LOADING = 'RAS_SET_GRID_LOADING';
export const RAS_SET_ROW = 'RAS_SET_ROW';
export const RAS_SET_MODAL = 'RAS_SET_MODAL';
export const RAS_RELOAD_GRID = 'RAS_RELOAD_GRID';
